import { registerUser } from "../services/mightyWifiApi";
export function userSignupRequest(payload) {
  return disptach => {
    return registerUser(payload);
  };
}



// WEBPACK FOOTER //
// ./src/modules/actions/signupActions.js